import { useMountEffect } from '@react-hookz/web';
import { addBreadcrumb, captureException } from '@sentry/react';
import type { RouterLocation } from 'connected-react-router';
import { getLocation, push } from 'connected-react-router';

import useAuth from 'src/app/hooks/useAuth';
import { forgotPasswordSuccess, login } from 'src/app/router/paths';
import { useDispatch, useSelector } from 'src/app/state/store';

import { Container, ContinueButton, Description, Header } from '../styles';

export const PasswordResetRequired = () => {
  const dispatch = useDispatch();
  const location: RouterLocation<any> = useSelector(getLocation);
  const email: string = location.state?.email;
  const { forgotPassword } = useAuth();

  useMountEffect(() => {
    if (!email) dispatch(push(login.route));
  });

  const resetPasswordForEmail = async () => {
    try {
      await forgotPassword(email);
      dispatch(push(forgotPasswordSuccess.route));
    } catch (error: unknown) {
      addBreadcrumb({
        data: { email },
        message: 'Handled error without "caring" UI when triggering pw reset during "expired" password UI.',
      });
      captureException(error);
    }
  };

  return (
    <Container>
      <Header>Your password has expired</Header>

      <Description>Please continue to reset your password.</Description>

      <ContinueButton onClick={resetPasswordForEmail} />
    </Container>
  );
};
